import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="智能塔后台管理系统（zntMangerSystem）"
      links={[]}
    />
  );
};

export default Footer;
